import {useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import ReadModal from './ReadModal'
import {onGet, transNum, isArNum} from '../Shared/Akademy'
import './Reading.css'

const ReadControl = ({path,onPath,part,page, onPrev,onNext, onPart, onPage, modal=false, Etat}) => {
    const [expanded, Expand] = useState(false)
    const [play, Play] = useState(false)
    const [wajh, Wajh] = useState({jpg:"", mp3:"", view:false})
    const [ward, Ward] = useState({x: 0, y: 0})
    const [items , Items] = useState([])

    const [version, Version] = useState(1)
    const [following, Follow] = useState(false)

    let istyle={display: 'flex', justifyContent: 'center'}
    let tstyle = { position:'absolute', top:'95%', width: '4rem', height: '5%', fontWeight:'bold', color:'darkred'}

    const safha = document.getElementById("safha");
    const audio = document.getElementById("tilaawa");
 
    useEffect(()=>{
        onGet(`/safahaat/${page}`, Items)

        const file=path+(version===1?'warsh/':'hafs/')+(page||0).toString().padStart(3,'0');
        //alert(`Loading version ${version} page ${page}`)

        Wajh({...wajh, jpg: file+'.jpg', mp3: file+'.mp3'})

        onPath && onPath(file.slice(0, file.lastIndexOf("/") + 1))
        onPage && onPage(page)

        if(play && onPlay) {
            onPlay()
        }

    },[version, page])

    useEffect(()=>{
        const mePage = document.getElementById("mePage");
        if(mePage && mePage.value !== page) {
            mePage.value = page;
            //alert(`Loading version ${version} page ${page}`)
        }
    },[page])

    const onPlay = () => {
        if(!play) {
            audio.play()
            audio.style.visibility='visible'
        }
        else {
            audio.pause()
            audio.style.visibility='hidden'
        }
        Play(!play)
    }
    //audio.stopAll();

    useEffect(()=>{    
        const follow = document.getElementById("meFollow");
        follow.innerHTML = following ? "توقف" : "متابعة";
        follow.style.backgroundColor = following ? "red" : "green";

    },[following])

    const onFollow = e => {
        //alert(`متابعة ${!following ? "الصفحة" : "إلغاء المتابعة"} ${page} من ${part.id}`)
       
        Follow(!following);
    }

    useEffect(()=>{

        if(!safha) return;

        const meNass = document.getElementById("meNass");
        meNass.innerHTML = wajh.view ? "إخفاء" : "النص";
        meNass.style.backgroundColor = wajh.view ? "blue" : "gray";

        const bNass = document.getElementById("bNass"); 
        bNass.style.visibility = wajh.view ? "visible" : "hidden";
        //alert(`nass ${wajh.nass} ${wajh.view} !`)
        if(wajh.view) {
            safha.style.cursor = "text"; // to indicate text selection
            safha.style.visibility = "hidden";

            if(items.length>0) {
                const Allah = "اللهم اَ۬للَّهَۖ اَ۬للَّهِ بِاللَّهِ اُ۬للَّهُ اَ۬للَّهَ لِلهِ اِ۬للَّهِ وَاللَّهُ اَ۬للَّهُ".split(" ");
                const Arrab = "رَبِّ رَّبِّهِمْۖ رَبَّكُمُ رَبُّكَ رَّبِّهِ".split(" ");

                let kalimaat = items[0]?.Kalimaat.split(" ") || []; 
                let nass = items[0]?.Nass || "إظهار النص";

                //nass = transNum(nass); // تحويل الأرقام إلى العربية

                let lines = nass.split(/\r\n|\r|\n/);
               
                bNass.innerHTML = lines.map((line, index) => `<p key=${"l-"+index}>${
                    line.split(/\s+/).map((word, windex) => {
                        if(Allah.includes(word)) {
                           return `<span key=${"a-"+windex} class="Noor">${word}</span>`;
                        }
                        else if(Arrab.includes(word)) {
                           return `<span key=${"u-"+windex} class="Noor Noor2">${word}</span>`;
                        }
                        else if(isArNum(word)) {
                            return `<span key=${"n-"+windex} class="rakm">${transNum(word)}</span>`;
                        }
                        else if(kalimaat.includes(word)) {
                           return `<span key=${"u-"+windex} class="faryd">${word}</span>`;
                        }
                        else {
                           return `<span key=${"w-"+windex}>${word}</span>`; 
                        }
                    }).join(' ')    
                    
                }</p>`).join('');
            }
        }
        else {
            safha.style.visibility = "visible";
            safha.style.cursor = "pointer";
            //safha.style.opacity = "1";            
        }
    },[wajh.view, items])

    const onNass = e => {
        Wajh({...wajh, view : !wajh.view})

        //Nass("إظهار النص");
    }

    const onVersion = e => {
        e.preventDefault()
        let value=parseInt(e.target.value)
        Version(value)        
    }

    const onWajh = e => {
        e.preventDefault()
        let value=parseInt(e.target.value)
        onPage(value)        
    }

    const onWard = e => {

        if(following) {
            Ward({x: e.clientX, y: e.clientY, ch:parseInt(window.innerHeight*3/100)})
        }
        //alert(`onWard ${ward.x} ${ward.y} ${ward.ch} !`)
    }

    return (
        <div className="page-center">

        <img className="page-fit-center" id="safha" alt="القرآن الكريم" 
            src={wajh.jpg} onMouseDown={onWard}
        />
       
        <Button className="meNext mr-2" variant="outline-warning" 
            style={{ left:'1%'}}
            onClick={onNext}
            ><i className="fa fa-arrow-left" style={{display: 'flex', justifyContent: 'center'}}></i></Button>

        <Button className="meNext mr-2" variant="outline-warning" 
        style={{left:'94%'}}
            onClick={onPrev}
            ><i className="fa fa-arrow-right" style={{display: 'flex', justifyContent: 'center'}}></i></Button>

<audio id="tilaawa" controls="controls" autobuffer="autobuffer" 
    style={{position:'absolute',width:'90%', height:'5%', bottom:0, left:'5%', visibility:'hidden', opacity:'0.7'}} 
    src={wajh.mp3} />

<Button className="mr-2" variant={play?"outline-danger":"outline-success"}  
        style={{ position:'absolute', width: '10%', height: '5%', top:'100%', left:'45%', opacity:'0.7' }}
            onClick={onPlay}
            ><i className={play?"fa fa-pause":"fa fa-play"} style={istyle}></i></Button>

    <div style={{ ...tstyle,  top:'0', left:'0', color:'goldenrod' }}>
        <p>{part.id}</p>
    </div>

    <select className='options' id="meVersion" title='رواية' style={{...tstyle, left:'10%'}} 
        onChange={onVersion}
        defaultValue={version}
        >
		<option value="1">ورش</option>
        <option value="2">حفص</option>
    </select>
	<button class="options" id="meFollow" onClick={onFollow} style={{...tstyle, left:'60%'}}>متابعة</button>
	<button class="options" id="meNass" onClick={onNass} style={{...tstyle, left:'80%'}}>النص</button>

    <select className='options' id="mePage" title='صفحة' style={{...tstyle, left:'30%'}} 
        onChange={onWajh} 
        defaultValue={page}
    >
    	<option value="1">1</option>
    </select>

  <FollowControl following={following} safha={safha} audio={audio} Etat={Etat} />

{ !modal ?
    <Button className="mr-2" variant={"outline-info"}  
        style={{ position:'absolute', width: '6%', aspectRatio:'1 / 1', top:0, right:0, margin:'6px' }}
            onClick={()=>Expand(true)}
            ><i className={"fa fa-expand"} style={{display: 'flex', justifyContent: 'center'}}></i>
            </Button>    
: null }

{ expanded ?
    <ReadModal path={path} part={part} page={page} onPart={onPart} onPage={onPage} show={expanded} onHide={()=>Expand(false)} />
: null }

        </div>
    )
}

export default ReadControl

const FollowControl = ({following, safha, audio, Etat}) => {

    const bNass = document.getElementById("bNass"); // 250604 Nass
    const bForward = document.getElementById("bForward");
    const bBackward = document.getElementById("bBackward");
    const bread = document.getElementById("bread");
    const cw  = 120; // width of the forward and backward buttons
    const ch = parseInt(window.innerHeight*3/100);

    useEffect(() => {
        const pages = document.getElementById("mePage");
        for (let i = 2; i <= 604; i++) {
            let option = document.createElement("option");
            option.value = i;
            option.textContent = i;
            pages.appendChild(option);
        }
    }, [])

    function onWard(event) {
		if(safha) {
            const rect = safha.getBoundingClientRect(); 
			if(following) {

				bForward.left = (event.clientX - rect.left - 30)
				bForward.top  = (event.clientY - rect.top - ch)
			}
            setWard(rect);
		}
	}

    const setWard = (rect) => {

        bForward.style.left = bForward.left+"px";
        bForward.style.top  = bForward.top+"px";

        bBackward.style.top  = bForward.top+"px";
        bBackward.left = bForward.left + cw
        bBackward.style.left = bBackward.left+"px";
        bBackward.style.width = (rect.right - bBackward.left)+"px";

        bread.style.height = (bForward.top)+"px";
        bread.style.right = (0)+"px";
        bread.style.top = (0)+"px";
    }

    const onNass = e => {
        //alert(e.target.innerHTML);
    }

    return (

<>
	    <div class='Reading' id="bread" onMouseMove={onWard} onMouseDown={onWard}></div>
        <div class='Reading' id="bBackward" onMouseMove={onWard} onMouseDown={onWard}></div>
		<div class='Reading' id="bForward" onMouseMove={onWard} onMouseDown={onWard}></div>
        <div class='Reading' id="bNass" onMouseDown={onNass}></div>
</>                

    )
}


/**
 * {play?"fa fa-pause":"fa fa-play"}
 *     
 */